import request from './api'

export async function sendNewdogRequest(formData){
    try {
        const data = await request('/api/newdog/request', 'PUT', formData, 'multipart')
        return {
            isOk: true,
            message: data.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function clientSignRefused(id_req, id_file, message){
    try {
        const data = await request('/api/newdog/client-sign-refused', 'POST', {id_req, id_file, message})
        return {
            isOk: true,
            message: data.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function sendNewdogRequestUpdate(formData){
    try {
        const res = await request('/api/newdog/request-update', 'POST', formData, 'multipart')
        return {
            isOk: true,
            message: res.message,
            status: res.status
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function deleteNewDogReq(id){
    try {
        const res = await request('/api/newdog/request-delete', 'POST', {id})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getRequests(){
    try {
        const res = await request('/api/newdog/request', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}


export async function getTechConnection(kod_dog){
    try {
        const res = await request('/api/techconnection/objects', 'POST', {kod_dog})
        /*const res = {isOk:true, data:[
            {
                "id": 1,
                "date": "13.09.2022",
                "title": "Проект договора энергоснабжения (купли-продажи (поставки)электрической энергии",
                "explanation": "Проект договора энергоснабжения (купли-продажи (поставки)электрической энергии пояснение"
            },
            {
                "id": 2,
                "date": "22.09.2022",
                "title": "Акт допуска прибора учета к эсплуатации",
                "explanation": "Акт допуска прибора учета к эсплуатации пояснение"
            },
            {
                "id": 3,
                "date": "22.09.2022",
                "title": "Акт осуществления технологического присоединения (уведомления об обеспечении сетевой организации возможности присоединения к электрическим сетям)",
                "explanation": "Акт осуществления технологического присоединения (уведомления об обеспечении сетевой организации возможности присоединения к электрическим сетям) пояснение"
            },
            {
                "id": 4,
                "date": "26.09.2022",
                "title": "Соглашение о внесении изменений в договор энергоснабжения с описание существующих условий",
                "explanation": "Соглашение о внесении изменений в договор энергоснабжения с описание существующих условий пояснение"
            }
        ]}*/
        return {
            isOk: true,
            data: res.data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}


export async function getDogKind(){
    try {
        const res = await request('/api/newdog/dog-kind', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getConsumerTypes(){
    try {
        const res = await request('/api/newdog/consumer-types', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getObjTypes(){
    try {
        const res = await request('/api/newdog/obj-types', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getPriceKinds(){
    try {
        const res = await request('/api/newdog/price-kinds', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

/*const MOCK_DOC_RECEIVE = [
    {id: '1', name: 'электронный документооборот'},
    {id: '2', name: 'ЛК'},
    {id: '3', name: 'в офисе ООО «Р-Энергия»'},
]*/

export async function getDocReceive(){
    try {
        const res = await request('/api/newdog/options-doc_receive', 'POST', {doc_receive:1})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDogDocList(params){
    try {
        let body = null
        if (params != null && typeof params === 'object' && !Array.isArray(params)) {
            body = {}
            if (params.dogkind_id != null && params.dogkind_id !== '') body.dogkind_id = params.dogkind_id
            if (params.consumer_type_id != null && params.consumer_type_id !== '') body.consumer_type_id = params.consumer_type_id
            if (params.obj_type_id != null && params.obj_type_id !== '') body.obj_type_id = params.obj_type_id
            if (params.id_req_type != null && params.id_req_type !== '') body.id_req_type = params.id_req_type
            if (params.id != null && params.id !== '') body.id = params.id
            if (!Object.keys(body).length) body = null
        } else if (params != null) {
            body = {id: params}
        }
        const res = await request('/api/newdog/dog-doc-list', 'POST', body)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDepListDep(){
    try {
        const res = await request('/api/newdog/dep-list-dep', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDepListNet(){
    try {
        const res = await request('/api/newdog/dep-list-net', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getOptionsRadio(){
    try {
        const res = await request('/api/newdog/options', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e?.message
        }
    }
}

export async function getRequestAttach(idAttach){
    try {
        const res = await request('/api/newdog/request-attach', 'POST', {id: idAttach})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function delRequestAttach(id_file){
    try {
        const res = await request('/api/newdog/del-req-attach', 'POST', {id_file})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function sendMessage(formData){
    try {
        const res = await request('/api/newdog/message', 'PUT', formData, 'multipart')
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getMessages(idReq){
    try {
        const res = await request('/api/newdog/message', 'POST', {request: idReq})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

// export async function getMessageAttach(id){
//     try {
//         const res = await request('/api/newdog/message-attach', 'POST', {id: id})
//         return {
//             isOk: true,
//             data: res
//         }
//     } catch (e) {
//         return {
//             isOk: false,
//             message: e.message
//         }
//     }
// }

export async function getRegionsWithTariffs(){
    try {
        const res = await request('/api/newdog/region', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export function isInnReadyForBackendCheck(inn) {
    const length = String(inn ?? '').trim().length;
    return length === 10 || length === 12;
}

export async function checkINN(inn){
    try {
        const res = await request('/api/newdog/inn', 'POST', {inn: inn})
        if (res?.localOnly) {
            return {
                isOk: true,
                localOnly: true,
                data: []
            }
        }
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function daDataGet(query, type){
    try {
        const res = await request('/api/newdog/dadata', 'POST', {query, type})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getFileTypes(){
    try {
        const res = await request('/api/newdog/file-types', 'POST', null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function addFilesToOldReq(formData){
    try {
        const res = await request('/api/newdog/add-to-old-req', 'PUT', formData, 'multipart')
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getFinalDogovor(idReq){
    try {
        const res = await request('/api/newdog/final-dogovor', 'POST', {id: idReq})
            return {
                isOk: true,
                data: res.dogovor
            }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDogovorToSigned(idAttach){
    try {
        const res = await request('/api/newdog/sign-dogovor', 'POST', {id: idAttach})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function putSignDogovor(formData){
    try {
        const res = await request('/api/newdog/sign-dogovor', 'PUT', formData, 'multipart')
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDogovorZip(idFile){
    try {
        const res = await request('/api/newdog/dog-zip', 'POST', {id: idFile})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDogovorZipAll(id_req){
    try {
        const res = await request('/api/newdog/dog-zip-all', 'POST', {id_req})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDogovorRequests(kod_dog){
    try {
        /*const res = {isOk:true, data:[
                {
                    "id": 987,
                    "name_company": "ООО «Ромашка»",
                    "text_message": "Заявка на подключение электроснабжения нового производственного цеха",
                    "inn": "7701234567",
                    "kpp": "770101001",
                    "date_create": "2026-06-24T19:04:52.000Z",
                    "id_status": 1,
                    "kod_dog": 123456,
                    "kod_numobj": 555,
                    "status": "Черновик",
                    "region": "Москва",
                    "contact": "Иванов Иван Сергеевич",
                    "fio": "Иванов Иван Сергеевич",
                    "phone": "+79161234567",
                    "dogovor_type": 21,
                    "fin_src": "Собственные средства",
                    "contr_price": 1500000,
                    "contr_begin": "2026-06-01",
                    "contr_end": "2026-12-31",
                    "branch": "Московский филиал ПАО «Россети»",
                    "electrical_net": "Московская городская электросеть",
                    "ackt_tehn_num": "АТ-2026-08/1234",
                    "zip_code": "101000",
                    "id_fias": "77000000000000001",
                    "adress": "г. Москва, ул. Промышленная, д. 15, стр. 2",
                    "contr_date": "2026-06-24",
                    "bank": "ПАО «Сбербанк»",
                    "bic": "044525225",
                    "cor_account": "30101810400000000225",
                    "pay_account": "40702810500000012345",
                    "per_account": "40702810500000012346",
                    "treasury": "Отделение Москва",
                    "dev_agr_req": "Согласовано",
                    "destropy_req": "Не требуется",
                    "permission_req": "Получено",
                    "doc_receive": "Лично",
                    "settlement": "Безналичный расчёт",
                    "num_req": "123/2026",
                    "obj_num": "1",
                    "obj_name": "Производственный цех №3",
                    "obj_label": "Объект 1, Производственный цех №3",
                    "attachments": [
                        {
                            "id": 10,
                            "id_req": 987,
                            "direction": 1,
                            "file_type": 5,
                            "filename": "dogovor_987.pdf",
                            "name_type": "Договор",
                            "uuid": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
                            "size": 245780
                        },
                        {
                            "id": 11,
                            "id_req": 987,
                            "direction": 1,
                            "file_type": 3,
                            "filename": "tu_123456.pdf",
                            "name_type": "Технические условия",
                            "uuid": "b2c3d4e5-f6a7-8901-bcde-f12345678901",
                            "size": 512340
                        },
                        {
                            "id": 12,
                            "id_req": 987,
                            "direction": 2,
                            "file_type": 7,
                            "filename": "akt_2026_06.pdf",
                            "name_type": "Акт разграничения",
                            "uuid": "c3d4e5f6-a7b8-9012-cdef-123456789012",
                            "size": 187650
                        }
                    ]
                },
                {
                    "id": 988,
                    "name_company": "АО «ТехноСтрой»",
                    "text_message": "Заявка на увеличение выделенной мощности для торгового центра",
                    "inn": "7802345678",
                    "kpp": "780201001",
                    "date_create": "2026-06-20T10:30:15.000Z",
                    "id_status": 2,
                    "kod_dog": 123457,
                    "kod_numobj": 556,
                    "status": "На рассмотрении",
                    "region": "Санкт-Петербург",
                    "contact": "Петрова Мария Алексеевна",
                    "fio": "Петрова Мария Алексеевна",
                    "phone": "+79219876543",
                    "dogovor_type": 22,
                    "fin_src": "Кредитные средства",
                    "contr_price": 3200000,
                    "contr_begin": "2026-07-01",
                    "contr_end": "2027-03-31",
                    "branch": "Северо-Западный филиал ПАО «Россети»",
                    "electrical_net": "Петроградская электросеть",
                    "ackt_tehn_num": "АТ-2026-08/1235",
                    "zip_code": "190000",
                    "id_fias": "78000000000000002",
                    "adress": "г. Санкт-Петербург, Невский пр-т, д. 42",
                    "contr_date": "2026-06-20",
                    "bank": "АО «Альфа-Банк»",
                    "bic": "044525593",
                    "cor_account": "30101810200000000593",
                    "pay_account": "40702810900000054321",
                    "per_account": "40702810900000054322",
                    "treasury": "Северо-Западное ГУ ЦБ РФ",
                    "dev_agr_req": "В процессе",
                    "destropy_req": "Требуется",
                    "permission_req": "В процессе",
                    "doc_receive": "Почта",
                    "settlement": "Безналичный расчёт",
                    "num_req": "456/2026",
                    "obj_num": "2",
                    "obj_name": "Торговый центр «Невский»",
                    "obj_label": "Объект 2, Торговый центр «Невский»",
                    "attachments": [
                        {
                            "id": 13,
                            "id_req": 988,
                            "direction": 1,
                            "file_type": 5,
                            "filename": "dogovor_988.pdf",
                            "name_type": "Договор",
                            "uuid": "d4e5f6a7-b8c9-0123-defa-234567890123",
                            "size": 312450
                        },
                        {
                            "id": 14,
                            "id_req": 988,
                            "direction": 1,
                            "file_type": 4,
                            "filename": "proekt_rekonstrukcii.pdf",
                            "name_type": "Проект реконструкции",
                            "uuid": "e5f6a7b8-c9d0-1234-efab-345678901234",
                            "size": 1548720
                        },
                        {
                            "id": 15,
                            "id_req": 988,
                            "direction": 1,
                            "file_type": 8,
                            "filename": "single_line_scheme.pdf",
                            "name_type": "Однолинейная схема",
                            "uuid": "f6a7b8c9-d0e1-2345-fabc-456789012345",
                            "size": 425600
                        }
                    ]
                },
                {
                    "id": 989,
                    "name_company": "ООО «ЭнергоСервис-Казань»",
                    "text_message": "Заявка на технологическое присоединение складского комплекса",
                    "inn": "1650123456",
                    "kpp": "165001001",
                    "date_create": "2026-06-15T14:22:08.000Z",
                    "id_status": 3,
                    "kod_dog": 123458,
                    "kod_numobj": 557,
                    "status": "Подписан",
                    "region": "Республика Татарстан",
                    "contact": "Сидоров Алексей Петрович",
                    "fio": "Сидоров Алексей Петрович",
                    "phone": "+79172345678",
                    "dogovor_type": 23,
                    "fin_src": "Средства инвестора",
                    "contr_price": 8500000,
                    "contr_begin": "2026-08-01",
                    "contr_end": "2027-07-31",
                    "branch": "Казанский филиал ПАО «Россети»",
                    "electrical_net": "Казанские электрические сети",
                    "ackt_tehn_num": "АТ-2026-08/1236",
                    "zip_code": "420000",
                    "id_fias": "16000000000000003",
                    "adress": "Респ. Татарстан, г. Казань, ул. Промышленная зона, д. 7",
                    "contr_date": "2026-06-15",
                    "bank": "ПАО «ВТБ»",
                    "bic": "044525104",
                    "cor_account": "30101810300000000104",
                    "pay_account": "40702810700000098765",
                    "per_account": "40702810700000098766",
                    "treasury": "Национальный банк РТ",
                    "dev_agr_req": "Согласовано",
                    "destropy_req": "Не требуется",
                    "permission_req": "Получено",
                    "doc_receive": "Электронная почта",
                    "settlement": "Безналичный расчёт",
                    "num_req": "789/2026",
                    "obj_num": "3",
                    "obj_name": "Складской комплекс класса «А»",
                    "obj_label": "Объект 3, Складской комплекс класса «А»",
                    "attachments": [
                        {
                            "id": 16,
                            "id_req": 989,
                            "direction": 1,
                            "file_type": 5,
                            "filename": "dogovor_989_signed.pdf",
                            "name_type": "Договор",
                            "uuid": "a7b8c9d0-e1f2-3456-abcd-567890123456",
                            "size": 385420
                        },
                        {
                            "id": 17,
                            "id_req": 989,
                            "direction": 1,
                            "file_type": 6,
                            "filename": "ustav_organizacii.pdf",
                            "name_type": "Учредительные документы",
                            "uuid": "b8c9d0e1-f2a3-4567-bcde-678901234567",
                            "size": 2156780
                        },
                        {
                            "id": 18,
                            "id_req": 989,
                            "direction": 2,
                            "file_type": 9,
                            "filename": "akt_razgranicheniya_balansa.pdf",
                            "name_type": "Акт разграничения баланса",
                            "uuid": "c9d0e1f2-a3b4-5678-cdef-789012345678",
                            "size": 298450
                        }
                    ]
                }
            ]}
        return res*/

        const res = await request('/api/techconnection/requests', 'POST', {kod_dog})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}


export async function getDogovorObjects(kod_dog){
    try {
        const res = await request('/api/techconnection/objects', 'POST', {kod_dog})
        // const res = {isOk:true, data:[
        //     {
        //         "id": 1,
        //         "date": "13.09.2022",
        //         "title": "Проект договора энергоснабжения (купли-продажи (поставки)электрической энергии",
        //         "explanation": "Проект договора энергоснабжения (купли-продажи (поставки)электрической энергии пояснение"
        //     },
        //     {
        //         "id": 2,
        //         "date": "22.09.2022",
        //         "title": "Акт допуска прибора учета к эсплуатации",
        //         "explanation": "Акт допуска прибора учета к эсплуатации пояснение"
        //     },
        //     {
        //         "id": 3,
        //         "date": "22.09.2022",
        //         "title": "Акт осуществления технологического присоединения (уведомления об обеспечении сетевой организации возможности присоединения к электрическим сетям)",
        //         "explanation": "Акт осуществления технологического присоединения (уведомления об обеспечении сетевой организации возможности присоединения к электрическим сетям) пояснение"
        //     },
        //     {
        //         "id": 4,
        //         "date": "26.09.2022",
        //         "title": "Соглашение о внесении изменений в договор энергоснабжения с описание существующих условий",
        //         "explanation": "Соглашение о внесении изменений в договор энергоснабжения с описание существующих условий пояснение"
        //     }
        // ]}
        return {
            isOk: true,
            data: res.objects
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getDogovorDocuments(kod_dog){
    try {
        const res = await request('/api/techconnection/documents', 'POST', {kod_dog})
        return {
            isOk: true,
            data: res.objects
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

// Документы договора
export async function getObjectDocuments(kod_numObj){
    try {
        const res = await request('/api/techconnection/object-documents', 'POST', {kod_numObj})
        return {
            isOk: true,
            data: res.objects
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

// Документы договора
export async function postObjectDocuments(kod_numObj){
    try {
        const res = await request('/api/request/user-req', 'POST', {kod_numObj})
        return {
            isOk: true,
            data: res.objects
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

